module.exports = __webpack_public_path__ + "static/media/VE.0fc1c8f4.svg";